import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateTierMutation = createMutationHook(MembershipsCreatorV2ApiClient.createTier, {
  mutationKey: ['createTier'],
})
